// extracted by mini-css-extract-plugin
export default {"link":"gGLsaS","ButtonLiftedShadow":"hrty30","buttonLiftedShadow":"hrty30","label":"TCm_is","shd":"i_JO53","left":"s0UDBS","right":"gfLhvl"};